import React from 'react';
import { MobXProviderContext } from 'mobx-react';
import RootStore from '../store/RootStore';

export function useStores(): typeof RootStore {
  return React.useContext(MobXProviderContext) as typeof RootStore;
}
